import spinnerImgPurple from "@assets/images/sand-glass-purple.svg";
import spinnerImgGreen from "@assets/images/sand-glass.svg";
import { Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import cls from "classnames";
import React, { FC } from "react";
const useStyle = makeStyles(
  theme => ({
    paper: {
      width: "560px",
      padding: "48px 24px 46px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.2rem"
    },
    spinnerContainer: {
      position: "relative",
      margin: "0 0 80px"
    },
    spinnerGreen: {
      position: "absolute",
      animation: `$spin 0.9s ease-in-out infinite alternate`
    },
    "@keyframes spin": {
      "0%": { transform: "rotate(0deg)" },
      "20%": { transform: "rotate(0deg)" },
      "80%": { transform: "rotate(180deg)" },
      "100%": { transform: "rotate(180deg)" }
    },
    spinnerPurple: {
      position: "absolute",
      animation: `$spinFade 0.9s ease-in-out infinite alternate`
    },
    "@keyframes spinFade": {
      "0%": { transform: "rotate(180deg)", opacity: 0 },
      "20%": { transform: "rotate(180deg)", opacity: 0 },
      "80%": { transform: "rotate(360deg)", opacity: 1 },
      "100%": { transform: "rotate(360deg)", opacity: 1 }
    }
  }),
  { name: "ModalProcessing" }
);

interface ModalProcessing {
  className?: string;
  isCreateOrder?: boolean;
}
const ModalProcessing: FC<ModalProcessing> = ({ className, isCreateOrder }) => {
  const classes = useStyle();
  return (
    <Paper className={cls(classes.paper, className)}>
      <div className={classes.spinnerContainer}>
        <img
          src={spinnerImgGreen}
          className={classes.spinnerGreen}
          alt="spinner"
        />
        <img
          src={spinnerImgPurple}
          className={classes.spinnerPurple}
          alt="spinner"
        />
      </div>
      <MyTypography variant="h6" className={classes.caption}>
        The system is processing orders...
      </MyTypography>
      <MyTypography variant="body2">
        {isCreateOrder
          ? "กรุณาอย่า refresh หน้าจอ เมื่อสร้างใบสั่งซื้อสำเร็จ ท่านสามารถตรวจสอบใบสั่งซื้อได้ที่เมนู Search Order/Inquiry - Order Confirmation หากไม่พบคำสั่งซึ้อ หรือ ติดต่อ Customer Services: (02-586-5555 กด 11)"
          : "กรุณาอย่า refresh หน้าจอ เมื่อแก้ไขใบสั่งซื้อสำเร็จ ท่านสามารถตรวจสอบใบสั่งซื้อได้ที่เมนู Search Order/List of Sales Order"}
      </MyTypography>
    </Paper>
  );
};

export default ModalProcessing;
